package com.exura.features.publicplans.domain.model

import com.exura.features.plandefinition.domain.model.PlanContentSummary
import com.exura.features.publicplans.data.remote.dto.ProviderPublicPlanDto
import com.exura.features.storage.domain.model.DomainModel
import kotlinx.datetime.LocalDateTime

data class ProviderPublicPlan(
    override val id: String?,
    val globalEntryId: String,
    val isSharingEnabled: Boolean,
    val websiteLink: String,
    val qrCodeUri: String,
    val accessCode: String,
    val createdDate: LocalDateTime,
    val lastModifiedDate: LocalDateTime,
    val summary: PlanContentSummary,
    val statistics: PublicPlanStatistics,
    val history: List<PublicPlanServingEntry>,
) : DomainModel<ProviderPublicPlan, ProviderPublicPlanDto> {
    override fun toDto(): ProviderPublicPlanDto = ProviderPublicPlanDto(
        globalEntryId = globalEntryId,
        isSharingEnabled = isSharingEnabled,
        websiteLink = websiteLink,
        qrCodeUri = qrCodeUri,
        accessCode = accessCode,
        createdDate = createdDate.toString(),
        lastModifiedDate = lastModifiedDate.toString(),
        summary = summary,
        statistics = statistics,
    )

    override fun withId(id: String): ProviderPublicPlan = copy(id = id)

    companion object : DomainModel.Factory<ProviderPublicPlan, ProviderPublicPlanDto> {
        override fun fromDto(id: String?, dto: ProviderPublicPlanDto): ProviderPublicPlan = fromDto(
            id = id,
            history = emptyList(),
            dto = dto,
            )

        fun fromDto(id: String?, history: List<PublicPlanServingEntry>, dto: ProviderPublicPlanDto): ProviderPublicPlan = ProviderPublicPlan(
            id = id,
            globalEntryId = dto.globalEntryId,
            isSharingEnabled = dto.isSharingEnabled,
            websiteLink = dto.websiteLink,
            qrCodeUri = dto.qrCodeUri,
            accessCode = dto.accessCode,
            createdDate = LocalDateTime.parse(dto.createdDate),
            lastModifiedDate = LocalDateTime.parse(dto.lastModifiedDate),
            summary = dto.summary,
            statistics = dto.statistics,
            history = history,
        )
    }
}
